const CATALOG_FILTER_STORAGE_KEY = 'catalog_filter';

export default {
  namespaced: true,
  state: {
    filter_sync: false,
    formato: [],
    origem: [],
    generos: [],
    anos: [],
    movie: [],
    person: [],
    estudio: [],
    total_membros: null,
    total_titulos: null,
    total_midias: null,
    total_trocas: null,
    correios: true,
    boleto: 0.00,
    pix: null,
  },
  getters: {
    isSyncronized: state => {
      return state.filter_sync
    },
  },
  actions: {
    setCatalogFilterData({ commit }, payload) {
      return commit('setCatalogFilterData', payload);
    },
    setMovieData({ commit }, payload) {
      return commit('setMovieData', payload);
    },
    setPersonData({ commit }, payload) {
      return commit('setPersonData', payload);
    },
    setStudioData({ commit }, payload) {
      return commit('setStudioData', payload);
    },
    setDubladorTitulo({ commit }) {
      return commit('setDubladorTitulo');
    },
    setStudioTitulo({ commit }) {
      return commit('setStudioTitulo');
    },
  },
  mutations: {
    setMovieData(state, payload) {
      state.movie = [];
      state.movie = payload.data;
    },
    setPersonData(state, payload) {
      state.person = [];
      state.person = payload.data;
    },
    setStudioData(state, payload) {
      state.estudio = [];
      state.estudio = payload.data;
    },
    setDubladorTitulo(state) {
      var titles = {};
      var mediaIds = [];
      var totalPapeis = 0;
      state.person.papeis.forEach(function(item){
        const titulo_id = item.titulo.id;
        const titulo_name = `${item.titulo.titulo_traduzido} (${item.titulo.ano})`;
        const papel = item.papel;
        const audio = item.audio;
        const estudio = item.estudio;
        const papel_string = `${papel} - ${estudio}`;
        var list = titles[titulo_id];
        totalPapeis = totalPapeis + 1;
        if(list){
          delete item.titulo;
          item.titulo_id = titulo_id;
          item.titulo = titulo_name;
          //console.log(mediaIds);
          item.midias.forEach(function(midia) {
            if(mediaIds.indexOf(midia.id) == -1) {
              titles[titulo_id]['midias'].push(midia);
            }
          });
          //titles[titulo_id]['midias'] = item.midias;
          titles[titulo_id]['papeis'].push({
            'papel': papel_string,
            'audio': audio,
          });
          //console.log(papel);
        }else{
          titles[titulo_id] = item.titulo;
          delete item.titulo;
          item.titulo_id = titulo_id;
          item.titulo = titulo_name;
          //titles[titulo_id]['papeis'] = [papel];
          item.midias.forEach(function(midia) {
            if(mediaIds.indexOf(midia.id) == -1) {
              mediaIds.push(midia.id);
            }
          });
          titles[titulo_id]['midias'] = item.midias;
          titles[titulo_id]['papeis'] = [];
          titles[titulo_id]['papeis'].push({
            'papel': papel_string,
            'audio': audio,
          });
        }
      });
      state.person.titulos = Object.values(titles);
      delete state.person.papeis;
      state.person.papeis = totalPapeis;
    },
    setStudioTitulo(state) {
      var titles = {};
      var mediaIds = [];
      var totalElencos = 0;
      state.estudio.elencos.forEach(function(item){
        const titulo_id = item.titulo.id;
        const titulo_name = `${item.titulo.titulo_traduzido} (${item.titulo.ano})`;
        const estudio = item.estudio_dublagem;
        const versao = item.versao;
        const estudio_string = ( !versao ) ? estudio : `${estudio} - ${versao}`;
        var list = titles[titulo_id];
        totalElencos = totalElencos + 1;
        if(list){
          delete item.titulo;
          item.titulo_id = titulo_id;
          item.titulo = titulo_name;
          item.midias.forEach(function(midia) {
            if(mediaIds.indexOf(midia.id) == -1) {
              titles[titulo_id]['midias'].push(midia);
            }
          });
          titles[titulo_id]['elencos'].push({
            'estudio': estudio_string,
          });
        }else{
          titles[titulo_id] = item.titulo;
          delete item.titulo;
          item.titulo_id = titulo_id;
          item.titulo = titulo_name;
          item.midias.forEach(function(midia) {
            if(mediaIds.indexOf(midia.id) == -1) {
              mediaIds.push(midia.id);
            }
          });
          titles[titulo_id]['midias'] = item.midias;
          titles[titulo_id]['elencos'] = [];
          titles[titulo_id]['elencos'].push({
            'estudio': estudio_string,
          });
        }
      });
      state.estudio.titulos = Object.values(titles);
      delete state.estudio.elencos;
      state.estudio.elencos = totalElencos;
    },
    setCatalogFilterData(state, payload) {
      /* atualiza o state dos filtros */
      state.anos = payload.data.anos;
      state.formato = payload.data.formato;
      state.origem = payload.data.origem;
      state.generos = payload.data.generos;

      /* atualiza o state das estatísticas do site */
      state.total_membros = payload.data.total_membros;
      state.total_titulos = payload.data.total_titulos;
      state.total_midias = payload.data.total_midias;
      state.total_trocas = payload.data.total_trocas;

      state.correios = payload.data.correios;
      state.boleto = payload.data.boleto;
      state.pix = payload.data.pix;
      state.filter_sync = true;
    },
  }
};
